import { useQuery } from '@tanstack/react-query';
import { getPrice, getPrices } from '../api/prices';


export const usePrices = (groupId: number) => {
  return useQuery({
    queryKey: ['prices', groupId],
    queryFn: () => getPrices(groupId),
    enabled: !!groupId,
  });
};
export const usePrice = (priceId: number) => {
  return useQuery({
    queryKey: ['priceById', priceId],
    queryFn: () => getPrice(priceId),
    enabled: !!priceId,
  });
};
